// @flow

import { PIT_STATS_REQUEST, PIT_STATS_SUCCESS, PIT_STATS_FAILURE, PIT_STATS_RESET } from './constant';

const initialState = {
  error: '',
  stats: {
    vehicleInsidePitToday: 0,
    vehicleHeadingToPitToday: 0,
    materialDispatchedFromPitToday: 0,
    materialDispatchedFromPitYesterday: 0,
  },
};

export default function reducer(state: PitStoreType = initialState, action: ActionType): PitStoreType {
  switch (action.type) {
    case PIT_STATS_REQUEST: {
      const {
        payload: { pitNumber },
      } = action;
      return {
        ...state,
        pitNumber,
      };
    }
    case PIT_STATS_SUCCESS: {
      const { payload } = action;
      return {
        ...state,
        stats: payload,
      };
    }
    case PIT_STATS_FAILURE: {
      return {
        ...initialState,
        error: 'Something went wrong! Please try again.',
      };
    }
    case PIT_STATS_RESET: {
      return {
        ...initialState,
      };
    }
    default:
      return state;
  }
}
